"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
function CheckBox(props) {
    const { onChange, checked, className, large } = props;
    const [ck, setChecked] = (0, react_1.useState)(checked);
    return (react_1.default.createElement("span", { role: "button", className: (0, util_1.cnx)(className), onClick: () => {
            onChange(!ck);
            setChecked(!ck);
        } }, ck ? (react_1.default.createElement(react_icons_1.IOCheckboxOutline, { size: large ? react_icons_1.ISize.MD : react_icons_1.ISize.SM })) : (react_1.default.createElement(react_icons_1.IOSquareOutline, { size: large ? react_icons_1.ISize.MD : react_icons_1.ISize.SM }))));
}
exports.default = CheckBox;
CheckBox.defaultProps = {
    className: undefined,
    large: false,
    disabled: false,
};
